export default function removeNbspStringUtil (htmlString) {
  return htmlString.replace(/&nbsp;+/g, '')
}
